(function () {
  pagination(true);
})();

function backgroundVideoLoop() {
  // Pico background loop
  const $video = document.querySelector('.pico-background');
  const sources = [];
  $video.play();
  $video.querySelectorAll('source').forEach($sourceEl => {
    sources.push($sourceEl.src);
  });
  let currentlyPlaying = $video.src;

  $video.addEventListener('ended', () => {
    const next = sources.filter(item => item !== currentlyPlaying)[0];
    currentlyPlaying = next;
    $video.src = next;
    $video.play();
  }); 
}

(function () {
    if (!document.body.classList.contains('is-article-header-image')) return;

    const cover = document.querySelector('.gh-cover');
    if (!cover) return;

    const header = document.querySelector('.gh-head');
    const image = cover.querySelector('.gh-article-image img');

    window.addEventListener('load', function () {
        const coverHeight = image.clientWidth * image.naturalHeight / image.naturalWidth;
        cover.style.setProperty('--cover-height', (Math.max(490, coverHeight) - header.offsetHeight) + 'px');
        cover.classList.remove('loading');
    });
})();

(function () {
  if (!document.body.classList.contains('home-template')) return;

  setTimeout(() => {
    const gallery = new Swiper('.gh-itinerary-list', {
      effect: "cards",
      grabCursor: true,
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },

    });
  }, 1000);
})();
